<template>
  <picture v-if="props.src" class="atomic-picture">
    <source :srcset="createSrcSet(props.src)" />
    <img
      ref="imageRef"
      :src="props.src"
      v-bind="$attrs"
      alt=""
      loading="lazy"
      @load="onLoad"
    />
  </picture>
</template>

<script setup>
const props = defineProps({
  src: String,
});

const emit = defineEmits(["loaded"]);
const { createSrcSet } = useProjectMethods();

const imageRef = ref(null);

const onLoad = () => {
  if (imageRef.value?.complete && imageRef.value.naturalWidth !== 0) {
    emit("loaded", imageRef.value);
  }
};

onMounted(async () => {
  await nextTick();
  if (imageRef.value?.complete) {
    emit("loaded", imageRef.value);
  }
});
</script>

<style lang="scss" src="~/assets/styles/components/atomic/picture.scss" />
